import { Azienda } from './azienda';
import { Commessa } from '../models/commessa';
import { Tipopagamento } from '../models/tipopagamento';
import { Metodopagamento } from '../models/metodopagamento';

export class Pagamento {
  Id: number;
  Datapagamento: Date;
  Importo: number;
  Note: string;
  Azienda: Azienda;
  Commessa: Commessa;
  Tipopagamento: Tipopagamento;
  Metodopagamento: Metodopagamento;
  Docfiscale: string;
//  Codicecommessa: number;
//  Codiceazienda: number;
//  Codicetipopagamento: number;
//  Codicemetodopagamento: number;

  constructor(){
    this.Id=0;
    this.Datapagamento=new Date();
    this.Importo= 0;
    this.Note= '';
    this.Azienda= new Azienda();
    this.Commessa= new Commessa();
    this.Tipopagamento=new Tipopagamento();
    this.Metodopagamento=new Metodopagamento();
    this.Docfiscale='';
//  this.Codicecommessa=0;
//    this.Codiceazienda=0;
//    this.Codicetipopagamento=0;
//    this.Codicemetodopagamento=0;
  }
}
